import React from 'react';
import {
  Outlet,
  useLocation,
  UNSAFE_LocationContext,
} from 'react-router-dom';

/**
 * When /notifications is open as an intercepting overlay, the parent <Routes>
 * matches against `backgroundLocation` so the prior page stays mounted.
 * This restores that background location for child hooks (useLocation / params).
 */
export default function InterceptingOutlet({ isOverlay }) {
  const location = useLocation();
  const backgroundLocation = location.state?.backgroundLocation;

  if (isOverlay && backgroundLocation) {
    return (
      <UNSAFE_LocationContext.Provider
        value={{
          location: backgroundLocation,
          navigationType: 'POP',
        }}
      >
        <Outlet />
      </UNSAFE_LocationContext.Provider>
    );
  }

  return <Outlet />;
}
